<template>
  <section id="record-list">
    <b-card>
      <b-card-body>
        <b-row>
          <b-col>
            <b-button
              variant="gradient-success"
              @click="showModal()"
            >
              اضافه کردن تردد
            </b-button>

            <vue-json-to-csv
              :json-data="desserts2"
              :labels="{
                karkard: { title: 'کارکرد' },
                timeEntry: { title: 'ساعت ورود' },
                timeExit: { title: 'ساعت خروج' },
                officetitle: { title: 'دفتر' },
                date: { title: 'تاریخ' },
              }"
              :csv-title="'کارکرد'"
            >
              <b-button
                color="success"
                class="mr-6"
              >
                Export <i
                  class="mdi mdi-export-variant"
                  aria-hidden="true"
                />
              </b-button>
            </vue-json-to-csv>
          </b-col>
          <b-col>
            <b-form-group
              label="فیلتر پرسنل:"
              label-for="vi-port"
            >

              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <feather-icon icon="UserIcon" />
                </b-input-group-prepend>
                <b-form-select
                  v-model="selected"
                  @change="getSelectedItem"
                >
                  <option
                    selected
                    disabled
                    value=""
                  >
                    انتخاب کنید
                  </option>
                  <option
                    v-for="item in listUser"
                    :value="item.userId._id"
                  >
                    {{ item.fName }} {{ item.lName }}
                  </option>
                </b-form-select>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <br>
        <v-data-table
          :headers="headers"
          :items="desserts"
          :items-per-page="40"
          :sort-by.sync="columnName"
          :sort-desc.sync="isDescending"
          mobile-breakpoint="0"
        >
          <template v-slot:item.officetitle="{ item }">
            <tr
              v-for="row in item.riz"
              :key="row._id"
            >
              {{ row.officetitle }}
            </tr>
          </template>
          <template v-slot:item.vorod="{ item }">
            <tr v-for="row in item.riz">
              {{ row.timeEntry }}
            </tr>
          </template>
          <template v-slot:item.khoroj="{ item }">
            <tr v-for="row in item.riz">
              {{ row.timeExit }}
            </tr>
          </template>
          <template v-slot:item.rizkarkard="{ item }">
            <tr v-for="row in item.riz">
              <span
                v-if="row.userEdit !== null"
                style="color: #9e9d24"
                :title="'ویرایش شده توسط '+row.userEdit"
              >
                {{ row.karkard }}
              </span>
              <span v-else>{{ row.karkard }}</span>

              <v-icon
                small
                color="#cc0"
                @click="EditItem(item,row)"
              >
                mdi-pencil
              </v-icon>
            </tr>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon
              small
              @click="deleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </template>
          <template v-slot:no-data>
            <v-btn
              variant="gradient-success"
              @click="initialize"
            >
              بروزرسانی
            </v-btn>
          </template>
        </v-data-table>
      </b-card-body>
    </b-card>

    <b-modal
      id="record-add"
      ref="record-add"
      cancel-variant="outline-secondary"
      ok-title="ذخیره"
      cancel-title="بستن"
      centered
      title="تردد"
    >
      <v-form>
        <v-container>
          <v-row v-if="record.recordId===''">
            <v-col
              cols="12"
              sm="6"
            >
              <b-input-group class="input-group-merge" >
                <b-input-group-prepend is-text>
                  <feather-icon icon="UserIcon" />
                </b-input-group-prepend>
                <b-form-select
                  v-model="record.userId"
                >
                  <option
                    selected
                    disabled
                    value=""
                  >
                    انتخاب کنید
                  </option>
                  <option
                    v-for="item in listUser"
                    :value="item.userId._id"
                  >
                    {{ item.fName }} {{ item.lName }}
                  </option>
                </b-form-select>
              </b-input-group>
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <feather-icon icon="UserIcon" />
                </b-input-group-prepend>
                <b-form-select
                  v-model="record.officeId"
                >
                  <option
                    selected
                    disabled
                    value=""
                  >
                    انتخاب کنید
                  </option>
                  <option
                    v-for="item in listOffice"
                    :value="item._id"
                  >
                    {{ item.title }}
                  </option>
                </b-form-select>
              </b-input-group>
            </v-col>
            <v-col
              cols="12"
              sm="12"
            >
              <date-picker
                v-model="record.date"
                label="تاریخ"
                style="margin: 0 5px;"
                append-to="body"
              />
            </v-col>
          </v-row>
            <v-row>
              <v-col
                  cols="12"
                  sm="6"
              >
                <span
                v-for="item in listUser">
                  <span
                  v-if="item.userId._id == record.userId"
                  >
                    {{ item.fName }} {{ item.lName }}
                  </span>
                </span>
              </v-col>
              <v-col
                  cols="12"
                  sm="6"
              >
                <span
                    v-for="item in listOffice">
                  <span
                      v-if="item._id == record.officeId"
                  >
                    {{ item.title }}
                  </span>
                </span>
              </v-col>
              <v-col
                  cols="12"
                  sm="6"
              >
              </v-col>
            </v-row>
            <v-row>
            <v-col
              cols="12"
              sm="6"
            >
              <date-picker
                v-model="record.timeEntry"
                label="ساعت ورود"
                style="margin: 0 5px;"
                append-to="body"
                type="time"
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <date-picker
                v-model="record.timeExit"
                label="ساعت خروج"
                style="margin: 0 5px;"
                append-to="body"
                type="time"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-form>
      <template #modal-footer="">
        <b-button
          size="sm"
          variant="danger"
          @click="$bvModal.hide('record-add')"
        >
          بستن
        </b-button>
        <b-button
          size="sm"
          variant="success"
          @click="modalUpdateRecord()"
        >
          ذخیره
        </b-button>
      </template>
    </b-modal>
  </section>

</template>
<script>
import {
  BCard, BCardBody, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination, BFormGroup, BFormSelect, BInputGroup,
  BInputGroupPrepend,
} from 'bootstrap-vue'
import Vue from 'vue'
// eslint-disable-next-line import/extensions
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import VueJsonToCsv from 'vue-json-to-csv'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import momentTZ from 'moment-timezone'
import moment from 'jalali-moment'
import router from '@/router'
import Config from '../../../config'
import recordService from '@/services/record.service'
import userService from '@/services/user.service'
import OfficeService from '../../services/office.service'

export default {
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BInputGroup,
    BFormGroup,
    BFormSelect,
    BInputGroupPrepend,
    VueJsonToCsv,
    datePicker: VuePersianDatetimePicker,
  },
  data() {
    return {
      date: Vue.prototype.$functions.unixToPersianDateS(Vue.prototype.$functions.time()),
      timeEntry: '',
      timeExit: '',
      officeId: '',
      columnName: 'date',
      isDescending: true,
      desserts: [],
      desserts2: [],
      listUser: [],
      listOffice: [],
      record: {
        recordId: '', userId: '', officeId: '', date: '', timeEntry: '', timeExit: '',
      },
      selected: 0,
    }
  },
  computed: {
    headers() {
      return [
        { text: 'تاریخ', value: 'date' },
        { text: 'محل کار', value: 'officetitle' },
        { text: 'ورود', value: 'vorod', sortable: false },
        { text: 'خروج', value: 'khoroj', sortable: false },
        { text: 'کارکرد', value: 'rizkarkard', sortable: false },
        { text: 'جمع کارکرد', value: 'jamkarkard' },
        { text: 'عملیات', value: 'actions', sortable: false },
      ]
    },
  },
  async created() {
    this.userfilll()
    this.getOfficeList()
  },
  mutations: {
    deleteItem(state, payload) {
      state.items.splice(payload, 1)
      // eslint-disable-next-line no-underscore-dangle
    },
  },
  methods: {
    modalUpdateRecord() {
      let timeEntry = null
      let timeExit = null
      if (this.record.timeEntry !== 'Invalid date') {
        timeEntry = moment(`${this.record.date} ${this.record.timeEntry}`, 'jYYYY/jMM/jDD HH:mm')
        timeEntry = Date.parse(timeEntry) / 1000
      }
      if (this.record.timeExit !== 'Invalid date') {
        timeExit = moment(`${this.record.date} ${this.record.timeExit}`, 'jYYYY/jMM/jDD HH:mm')
        timeExit = Date.parse(timeExit) / 1000
      }
      if (timeExit !== null && timeEntry !== null) {
        if (timeExit <= timeEntry) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'خطا',
              text: 'ساعت خروج نمی تواند قبل از ساعت ورود باشد.',
              icon: 'XIcon',
              variant: 'danger',
            },
          })
          return
        }
      }

      const data = {
        companyId: localStorage.getItem('companySelected'),
        recordData: {
          officeId: this.record.officeId,
          recordId: this.record.recordId,
          timeEntry,
          timeExit,
          userId: this.record.userId,
        },
      }

      recordService.update(data).then(
        res => {
          if (res.status === 'success') {
            this.initialize()
            this.hideModal()
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'register error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    getSelectedItem(myarg) {
      this.selected = myarg
      this.initialize()
    },
    userfilll() {
      this.listUser = []
      userService.getList({ companyId: localStorage.getItem('companySelected') }).then(
        res => {
          if (res.status === 'success') {
            if ('result' in res && 'data' in res.result && res.result.data.length > 0) {
              for (let i = 0; i <= res.result.data.length - 1; i++) {
                if (i === 0) {
                  this.selected = res.result.data[i].userId._id
                  this.initialize()
                }
                this.listUser.push(res.result.data[i])
              }
            }
          }
        },
      )
    },
    getOfficeList() {
      OfficeService.getList({ companyId: localStorage.getItem('companySelected') }).then(
        res => {
          if (res.status === 'success') {
            if ('result' in res && 'data' in res.result && res.result.data.length > 0) {
              for (let i = 0; i <= res.result.data.length - 1; i++) {
                this.listOffice.push(res.result.data[i])
              }
            }
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'register error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    initialize() {
      this.desserts = []
      this.desserts2 = []
      recordService.getList({
        companyId: localStorage.getItem('companySelected'),
        officeId: 0,
        filterUser: [this.selected],
        fromDate: 0,
        toDate: 0,
      }).then(
        res => {
          if (res.status === 'success') {
            let lastDate = 0
            let lastUser = 0
            if ('result' in res && 'data' in res.result && res.result.data.length > 0) {
              for (let i = 0; i <= res.result.data.length - 1; i++) {
                const temp = res.result.data[i]
                const riz = {}
                riz.userEdit = null
                if (typeof temp.userCreated !== 'undefined') {
                  console.log(temp.userCreated)
                  this.listUser.forEach(item => {
                    // eslint-disable-next-line no-underscore-dangle
                    if (item.userId._id === temp.userCreated) {
                      riz.userEdit = `${item.fName} ${item.lName}`
                      console.log(riz.name)
                    }
                  })
                }

                riz.karkard = 0
                riz.timeEntrys = temp.timeEntry
                riz.timeExits = temp.timeExit
                if (temp.timeExit) {
                  const hours = Math.floor((temp.timeExit - temp.timeEntry) / 3600)
                  const totalSeconds = (temp.timeExit - temp.timeEntry) % 3600
                  const minutes = Math.floor(totalSeconds / 60)
                  riz.karkard = `${hours}:${minutes}`
                }
                temp.date = new Date(temp.timeEntry * 1000).toLocaleDateString('fa-IR', { year: 'numeric', month: '2-digit', day: '2-digit' })
                riz.timeEntry = new Date(temp.timeEntry * 1000).toLocaleTimeString('fa-IR', { hour: '2-digit', minute: '2-digit' })
                riz.timeExit = '-'
                if (temp.timeExit) { riz.timeExit = new Date(temp.timeExit * 1000).toLocaleTimeString('fa-IR', { hour: '2-digit', minute: '2-digit' }) }
                riz.officetitle = temp.officeId.title
                // eslint-disable-next-line no-underscore-dangle
                riz._id = temp._id
                temp.userId.fullname = `${temp.userId.fName} ${temp.userId.lName}`

                if (lastDate !== temp.date || lastUser !== temp.userId.fullname) {
                  temp.riz = []
                  this.desserts.push(temp)
                }

                this.desserts[this.desserts.length - 1].riz.push(riz)
                lastDate = temp.date
                lastUser = temp.userId.fullname
              }
            }
            const tp = []
            for (let i = 0; i <= this.desserts.length - 1; i++) {
              const temp = this.desserts[i]
              temp.jamkarkard = 0
              let jam = 0
              temp.riz.forEach(val => {
                if (val.timeExits) {
                  jam += val.timeExits - val.timeEntrys
                }
                // eslint-disable-next-line no-param-reassign
               // delete val.timeEntrys
               // delete val.timeExits
                val.recordId = val._id
                delete val._id
                // eslint-disable-next-line no-param-reassign
                val.date = temp.date
                this.desserts2.push(val)
              })
              const hours1 = Math.floor(jam / 3600)
              const totalSeconds1 = jam % 3600
              const minutes1 = Math.floor(totalSeconds1 / 60)
              temp.jamkarkard = `${hours1}:${minutes1}`

              tp.push(temp)
            }
            this.desserts = tp
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'register error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    addClick() {
      router.push({ path: '/record/add' })
    },
    deleteItem(item) {
      let index = this.desserts.indexOf(item)
      // eslint-disable-next-line no-restricted-globals,no-unused-expressions
      if (confirm('Are you sure you want to delete this item?')) {
        recordService.delete({
          // eslint-disable-next-line no-underscore-dangle
          _id: this.desserts[index]._id,
          companyId: localStorage.getItem('companySelected'),
        }).then(
          res => {
            if (res.status !== 'success') {
              alert(JSON.stringify((res)))
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'register error',
                  text: res.result,
                  icon: 'XIcon',
                  variant: 'danger',
                },
              })
            } else {
              this.desserts.splice(index, 1)
            }
          },
          error => {
            this.message = (error.response && error.response.data)
                  || error.message
                  || error.toString()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'register error',
                text: this.message,
                icon: 'XIcon',
                variant: 'danger',
              },
            })
          },
        )
      } else {
        index = ''
      }
      // Todo: Make this delete item from store
      // eslint-disable-next-line no-underscore-dangle
    },

    showModal() {
      this.record = {
        recordId: '', userId: '', officeId: '', date: '', timeEntry: '', timeExit: '',
      }
      //  this.initializeOption()
      this.$refs['record-add'].show()
    },
    hideModal() {
      this.$refs['record-add'].hide()
    },
    EditItem(item,riz) {
      const index = this.desserts.indexOf(item)
      console.log(item)
      console.log('riz')
      console.log(riz)
      // eslint-disable-next-line no-underscore-dangle
      // const id = this.desserts[index]
      this.record = {
        // eslint-disable-next-line no-underscore-dangle
        recordId: riz.recordId,
        userId: item.userId.userId.toString(),
        officeId: item.officeId.officeId.toString(),
        date: Vue.prototype.$functions.unixToPersianDateS(item.timeEntry),
        timeEntry: Vue.prototype.$functions.unixToPersianTime(riz.timeEntrys),
        timeExit: Vue.prototype.$functions.unixToPersianTime(riz.timeExits),
      }
      this.$refs['record-add'].show()
    },
  },
}
</script>
<style>
#record-list table thead tr {
  background: #f4f4f2;
}
#record-list table tr td, #record-list table tr th {
  border: 1px solid rgba(0,0,0,0.12) !important;
}
#record-list table thead tr th{
  font-size: 1rem;
  color: azure;
  font-size: 0.9rem;
  color: #2b2b2b;
  font-weight: bold;
}
</style>
